import * as React from 'react';
import { SearchBox } from '@fluentui/react/lib/SearchBox';

export const SearchBoxUnderlinedExample = () => <SearchBox placeholder="Search" underlined={true} />;
